var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUsers(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 10.8333C9.34097 10.8333 10.8334 9.34095 10.8334 7.5C10.8334 5.65905 9.34097 4.16666 7.50002 4.16666C5.65907 4.16666 4.16669 5.65905 4.16669 7.5C4.16669 9.34095 5.65907 10.8333 7.50002 10.8333Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.50002 10.8333C4.27835 10.8333 1.66669 13.0717 1.66669 15.8333H13.3334C13.3334 13.0717 10.7217 10.8333 7.50002 10.8333Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 10.8333C13.057 10.8333 13.6051 10.6937 14.0942 10.4273C14.5834 10.1609 14.9979 9.77611 15.3001 9.3082C15.6022 8.84028 15.7823 8.30411 15.8239 7.74868C15.8654 7.19324 15.7671 6.63625 15.538 6.12858C15.3088 5.62092 14.9561 5.17877 14.512 4.84254C14.068 4.5063 13.5468 4.2867 12.996 4.2038C12.4452 4.12089 11.8824 4.17733 11.359 4.36794C10.8357 4.55856 10.3684 4.87729 10 5.295M10 9.80417C10.7475 10.5892 11.8275 10.8333 12.5 10.8333C15.7217 10.8333 18.3333 13.0717 18.3333 15.8333H13.3333",
    stroke: "currentColor",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUsers);
export default __webpack_public_path__ + "static/media/users.828435f8b903298e2b5e5821caec1001.svg";
export { ForwardRef as ReactComponent };